import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms'

//Popup Components
import { AlertComponent } from '../../popup/alert.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { FreightTypeService } from 'app/services/freight-type.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { AuthWebService } from 'app/services/authweb.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-freight-type',
  templateUrl: './edit-freight-type.component.html',
  styleUrls: ['./edit-freight-type.component.css']
})
export class EditFreightTypeComponent implements OnInit {

  form;
  vType: any = {};
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean;  
  isDup = false; 
  selectedDisplay = 3;
  message = null;
  now = new Date();
  audit = { created: '', updated: '' };
  user = { LastName: '' };
  
  public isLoading = false;

  constructor(private service: FreightTypeService, private authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,
     public utility: UtilityServiceService,private toastr:ToastrService) { }

  ngOnInit() {

    this.initForm();
    // this.onChanges();
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.sub = this.route.params.subscribe(params => {
      if (this.router.url.indexOf('edit') != -1) {
        this.isEdit = true;
        this.lblHeading = 'Edit Freight Type';
        this.btnActionLabel = 'Update';
        const id = +params['id'];
        this.isLoading = true;
        this.service.getById(id).subscribe(result => {
          this.vType = result;
          this.isLoading = false;
          (<UntypedFormGroup>this.form)
            .setValue({
              id: this.vType.id
              , code: this.vType.code
              , description: this.vType.description
              , group_code: this.vType.group_code
              , sort_order: this.vType.sort_order
              , is_active: this.vType.is_active
              , display_ind: this.vType.display_ind
              , date_created: this.vType.date_created
              , date_modified: this.vType.date_modified
              , user_created: this.vType.user_created
              , user_modified: this.vType.user_modified
              , vehicle: (this.vType.vehicle) ? this.vType.vehicle:null
            }, { onlySelf: true });
          this.audit = this.utility.setAuditAttributes(this.vType.date_created, this.vType.user_created, this.vType.date_modified, this.vType.user_modified);
        });
      } else {
        this.isEdit = false;
        this.lblHeading = 'Add New';
        this.btnActionLabel = 'Save';
        this.audit = this.utility.setAuditAttributes(this.now, this.user.LastName, this.now, this.user.LastName); 
      }
    });
  }


  initForm() {
    this.form = new UntypedFormGroup({
      id: new UntypedFormControl()
      , code: new UntypedFormControl(this.vType.code, Validators.compose([Validators.required, <any>Validators.maxLength(12), Validators.pattern('[\\w\-\\s\\/]+')]))
      , description: new UntypedFormControl(this.vType.description, Validators.maxLength(100))
      , group_code: new UntypedFormControl(this.vType.group_code, Validators.compose([Validators.required, <any>Validators.maxLength(12)]))
      , sort_order: new UntypedFormControl(this.vType.sort_code, Validators.required)
      , is_active: new UntypedFormControl()
      , display_ind: new UntypedFormControl(this.vType.display_ind, Validators.required)
      , date_created: new UntypedFormControl()
      , date_modified: new UntypedFormControl()
      , user_created: new UntypedFormControl()
      , user_modified: new UntypedFormControl()
      , vehicle: new UntypedFormControl()
    });
    this.form.patchValue(this.utility.defaults);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit(obj: any) {    
    if (this.isDup) { return; }
    this.vType = obj;
    this.message = (this.isEdit) ? "Updating Freight Type..." : "Adding a new Freight Type...";
    if (this.isEdit) {
      this.vType.date_modified = new Date().toLocaleString();
      this.vType.user_modified = this.user.LastName;
      this.isLoading = true;
      //console.log(JSON.stringify(obj));
      this.service.update(this.vType).subscribe(result => {
        this.vType = result;
        this.isLoading = false;
        //this.dialogService.addDialog(AlertComponent, { title: 'Update Vehicle Type', message: `Vehicle Type ${this.vType.code} updated succesfully.`, bold: `${this.vType.code}` });
        this.toastr.success(`Freight Type ${this.vType.code} updated succesfully.`,'Update Freight Type');
        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: `Update Vehicle Type`, message: `Failed to update Vehicle Type with ${this.vType.code}.Please contact the system administrator if the problem persists.`, bold: `${this.vType.code}` });
        this.toastr.error(`Failed to update Freight Type with ${this.vType.code}.Please contact the system administrator if the problem persists.`,'Update Vehicle Type');
      });
    } else {
      this.vType.date_modified = this.vType.date_created = new Date().toLocaleString();
      this.vType.user_modified = this.vType.user_created = this.user.LastName;

      this.isLoading = true;
      //console.log(JSON.parse(JSON.stringify(obj)));
      console.dir(this.vType);
      this.service.add(this.vType).subscribe(result => {
        this.vType = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'New Vehicle Type', message: `New Vehicle Type ${this.vType.code} added successfully.`, bold: `${this.vType.code}` });
        this.toastr.success(`New Freight Type ${this.vType.code} added successfully.`,'New Freight Type');
        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: `New Vehicle Type`, message: `Failed to add New Vehicle Type with ${this.vType.code}.Please contact the system administrator if the problem persists.`, bold: `${this.vType.code}` });
        this.toastr.error(`Failed to add New Freight Type with ${this.vType.code}.Please contact the system administrator if the problem persists.`,'New Vehicle Type');
      });
    }
  }

  navigate() {
    this.router.navigateByUrl('/freight/type/list');
  }

  onDuplicates(control) {


  }

  // onChanges(): void {
  //   this.form.get('code').valueChanges.subscribe(code => {

  //     if (code.length > 3) {
  //       this.service.checkByCode(code.trim()).subscribe(result => {
  //         this.isDup = (result.Status && !this.isEdit) ? true : false;
  //       }, error => {
  //         this.isDup = false;

  //       });
  //     }
  //   });    
  // }

}
